import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox } from "@chakra-ui/react";
  import { TopDisplay } from "../../../../components";
  import { IoMdAdd as AddIcon } from "react-icons/io";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState, useEffect } from "react";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import styled from "@emotion/styled";
  import { atom, useAtom } from 'jotai';
  import apiCall from '../../../../utils/apiCall';
  import {TopLink} from '../';
  import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
  import { Formik,Form,Field } from "formik";
  import {TablePopUp} from '../../../../components';
  import * as Yup from 'yup';
  import { format } from "date-fns";
  import { Loader } from "../../../../customs";
  import ReactPaginate from 'react-paginate';
  import { TbReload as ReloadIcon } from "react-icons/tb";

  // const allPromotionCond = [
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   } ,
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   },
  //   {
  //     Id:Math.floor(Math.random() * 10000)+1,
  //     ExamId:'12345',
  //     SubjectName:'Internet of things',
  //     Level:'2',
  //     CutOffMark: '50',
  //     Amount:'300,000'
  //   }  
  // ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type > *{
      display:none;
    }
    :hover > td{
      background-color:var(--table-highlight);
      &:last-of-type > *{
        display:block;
      }
    } 
    &.active > td:last-of-type > *{
      display:block !important;
    }  
  `  
  const PromotionCondAtom = atom<number | null>(null);
  
  export default function PromotionCond() {
    const [hide,set_hide] = useState<boolean>(true);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_open] = useAtom(openAtom);
    const [active] = useAtom<number | string | null>(PromotionCondAtom);
    const [selected_level,set_selected_level] = useState<null | number>(null);
    
  
      
  const {data:allLevel} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })
  
    const {isLoading,data:allPromotionCond} = useQuery(['exam-promotion'],{
      queryFn:async ()=> await apiCall().get(`/Exam/setup/promotionCondition`),
      select(data){
        return data.data.Data;
      }
    })
    const [search,set_search] = useState('');

    const [filter_data,set_filter_data] = useState<any>(allPromotionCond);
    const [filtered_data,set_filtered_data] = useState<any>(allLevel);

    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join(allPromotionCond).toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data('')
      }
      else set_filter_data(allPromotionCond)
    }
    const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    set_filter_data(allPromotionCond)
  },[allPromotionCond])

    const handleAddPromotionCond = () =>{
        set_modal({
          header:'Promotion Condition',
          content:<AddType />
        })
        set_open(true);
    }

    const handleFilter = (e:any) =>{
      const value = Number(e?.target?.value || 0);
      if(value || isNaN(value)){
        set_filtered_data(allPromotionCond?.filter((eData:any) => eData.LevelId == value))
      }
      else{
        set_filtered_data(allPromotionCond) 
      }

    } 
    useEffect(()=>{
      if(selected_level){
        let data = allLevel.filter((eData:any) => eData.Status === selected_level);
        if(data.length > 0){
          set_filter_data(data);
        }
      }
      else{
        set_filter_data(allLevel);
      }
    },[selected_level])
    
    useEffect(()=>{
      set_filtered_data(allPromotionCond)
    },[allPromotionCond])
  
    return (
      <> 
      {isLoading?<Loader />:
      <Box>
        <TopLink />
        <TopDisplay label="Promotion Condition SetUp" button_array={[
            <Button onClick={handleAddPromotionCond} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>SetUp Promotion Condition</Button>
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
            </InputGroup>
            {/* <Select placeholder="Level" width="100px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={handleFilter} >
              
              {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select> */}
            
  
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize="1rem">All Promotion Condition SetUp</Text>
            <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
       {  filtered_data && filtered_data.length > 0 ? <TableContainer mt="20px">
            <Table size='sm'>
              <Thead>
                <Tr >
                  {/* <Th sx={HeadStyle}>ID</Th> */}
                  <Th sx={HeadStyle}>Max.ExamPassed</Th>
                  <Th sx={HeadStyle}>Min.ExamPassed</Th>
                  <Th sx={HeadStyle}>Year</Th>
                  <Th sx={HeadStyle}>Level</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((ePromotionCond:any) =><ROWSTYLE key={ePromotionCond.Id} className={ePromotionCond.Id === active?'active':''}>
                  {/* <Td sx={DataStyle}>{ePromotionCond.Id}</Td> */}
                  <Td sx={DataStyle}>{ePromotionCond.MaxExamPassed}</Td>
                  <Td sx={DataStyle}>{ePromotionCond.MinExamPassed}</Td>
                  <Td sx={DataStyle}>{ePromotionCond.Year}</Td>
                  <Td sx={DataStyle}>{allLevel?.find((eLevel:any)=> eLevel.Id ==ePromotionCond?.LevelId)?.Name}</Td>
                  <Td sx={DataStyle} w="50px" h="50px">
                    <TempPopUp index={ePromotionCond.Id} data={ePromotionCond}/>
                  </Td>
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Promotion condition'  
        }
          <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
  
      </Box>
  }
      </>
     
    )
  }
  const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`


  const Label = styled.label``; 
  
  const AddSchema = Yup.object({
    Id:Yup.string(),
    LevelId:Yup.number().required(),
    MaxExamPassed:Yup.number().required(),
    MinExamPassed:Yup.number().required(),
    Year:Yup.number().required(),
  });
  
  const AddType = (props:any) =>{
    const queryClient = useQueryClient();
    const [,set_open] = useAtom(openAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    
    const {data:allLevel} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })
    
    const {mutate:addUpdate,isLoading} = useMutation({
      mutationKey:['new-promotion'],
      mutationFn:async (data:any)=> { return props && props.Id?await apiCall().put(`/exam/setup/promotionCondition/${props.Id}`,data):
       await apiCall().post(`/Exam/setup/promotionCondition`,data)},
      onSuccess:(data)=>{
        //console.log(data,'new data')
        set_notification({
          type:'success',
          message:data?.data?.Message || 'Exam promotion Condition Added Successfully'
        })
        set_Nopen(true);
        queryClient.invalidateQueries({
          queryKey:['exam-promotion']
        });
      },
      onError(error:any){
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:(data,error)=>{
        //console.log(data,error,'settle')
        set_open(false);
      }
    })

  
    return (
      <Formik
              initialValues={{
                MaxExamPassed: props.MaxExamPassed || '',
                MinExamPassed: props.MinExamPassed || '',
                Year: props.Year || '',  // Changed 'year' to 'Year'
                LevelId: props.LevelId || '',
              }}
      
            validationSchema={AddSchema}
            onSubmit={(values:any) => {
              //console.log('clicked')
              const data = {
                MaxExamPassed:values.MaxExamPassed,
                MinExamPassed:values.MinExamPassed,
                Year:values.Year,
                LevelId:values.LevelId,



              };
              console.log(data,'form data')
  
              addUpdate(data);
            }}
          >
           {(formik:any)=>{
          const {errors,values} = formik;
          // console.log(values,'values');
          // console.log(errors,'errors')
          return (
              <Form>
                 <Flex flexDir={"column"} align={"center"} gap="20px">
                 <Field as={Input}
                    bg='var(--white-color)'
                    borderColor='var(--dark-green-color)'
                    color='var(--dark-green-color)'
                    placeholder='MaxExamPassed'
                    name="MaxExamPassed"
                    type="number"
                  >
                  </Field>
                  <Field as={Input}
                    bg='var(--white-color)'
                    borderColor='var(--dark-green-color)'
                    color='var(--dark-green-color)'
                    placeholder='MinExamPassed'
                    name="MinExamPassed"
                    type="number"
                  >
                  </Field>
                  <Field
                      as={Input}
                      bg="var(--white-color)"
                      borderColor="var(--dark-green-color)"
                      color="var(--dark-green-color)"
                      placeholder="Year"
                      name="Year"
                      type="number" // Changed from "Type" to "type"
                       >
                    </Field>


                  <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Select Level'
                  name="LevelId"
                >
                  {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
                </Field>
                  
                  <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                    {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
                  
                
              </Form>
            )}}
          </Formik>
    )
  
  }
  
  const TempPopUp = (props:any) =>{
    const index = props.index;
    const data = props.data;
    // console.log(data,'data')
    const [active,set_active] = useAtom(PromotionCondAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const queryClient = useQueryClient();
    const {data:allLevel} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })
  
    // const {data:allSubject} = useQuery(['exam-subject'],{
    //   queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    //   select(data){
    //     return data.data.Data;
    //   },
    // })
    // const {mutate:deleteFee,isLoading} = useMutation({
    //   mutationKey:['delete-exam-subject'],
    //   mutationFn:async () => await apiCall().get(`/exam/setup/PromotionCond/${data?.Id}/delete`),
    //   onSuccess(data:any) {
    //     queryClient.invalidateQueries({queryKey:["exam-time-table"]})
    //     set_notification({
    //       type:'success',
    //       message:data?.data?.Message || 'Deleted Successfully'
    //     })
    //     set_Nopen(true);
    //   },
    //   onSettled(){
    //     set_open(false);
    //   }
    // })
  
    const handleClick = () =>{
      if(index === active){
        set_active(null);
        return;
      }
      else{
        set_active(index);
      }
    }
    const handleView= () =>{
      set_modal({
        header:'View Promotion Condition',
        content:<Grid>
          {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
            <span>Id</span>
            <span>{data?.Id}</span>
          </GridItem > */}
          <GridItem justify="space-between" p="10px 0" as={Flex}>
            <Text fontWeight="bold">Maximum Exam passed:</Text>
            <span>{data?.MaxExamPassed}</span>
          </GridItem >
          <GridItem justify="space-between" p="10px 0" as={Flex}>
            <Text fontWeight="bold">Minimum Exam Passed: </Text>
            <span>{data?.MinExamPassed}</span>
          </GridItem >
          
          <GridItem justify="space-between" p="10px 0" as={Flex}>
            <Text fontWeight="bold">Year:</Text>
            <span>{data?.Year}</span>
          </GridItem >
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">Level:</Text>
            <span>{allLevel?.find((eLevel:any)=> eLevel.Id == data?.LevelId)?.Name}</span>
          </GridItem>
        </Grid>
      })
      set_open(true);
      handleClick();
    }
    const handleEdit = () =>{
      handleClick();
      set_modal({
        header:'Edit Promotion Condition',
        content:<AddType {...data}/>
      });
      set_open(true);
      handleClick();
      
    }
    // const handleDelete = () =>{
    //   set_modal({
    //     header:'Delete Exam TimeTable',
    //     content:<Grid gap="20px">
    //       <GridItem>Are you Sure you want to delete this Exam Time Table?</GridItem>
    //       <GridItem as={Flex} justify="space-between" p="20px 0">
    //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
    //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
    //         <Button disabled={isLoading} 
    //           variant="outline" bg="var(--white-color)"
    //           onClick={()=>set_open(false)}
    //           border="1px solid var(--dark-green-color)"
    //           color="var(--dark-green-color)" >Cancel</Button>
    //       </GridItem>
    //     </Grid>
    //   });
    //   set_open(true);
    // }
    
    return (
      <TablePopUp click={handleClick} options={[
        {label:'View Condition',click:handleView},
        {label:'Edit Condition',click:handleEdit},
        // {label:'Delete Exam TimeTable',click:handleDelete}
      ]} />
    )
  }
  

function set_filter_data(arg0: any) {
  throw new Error("Function not implemented.");
}
  